import { TableConfig } from "../../../../../common/tables/config/TableConfig";
import { CostMetadataTableRow } from "../../../../../../../common/tables/cost-metadata/CostMetadataTableRow";
import { SortOrder } from "../../../../../../../common/query-filters";
import { CellType } from "../../../../../common/tables/config/CellType";

export const DefaultCostMetadataTableConfig: TableConfig<CostMetadataTableRow> = {
    columns: [
        {
            columnName: "id",
            displayName: "Cost Metadata ID",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "220px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "modifier",
            displayName: "Name",
            cellType: CellType.textInput,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "140px",
            sortable: true,
            filterable: true,
        },
        {
            columnName: "startDate",
            displayName: "Start Date",
            cellType: CellType.dateTimePicker,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "createdAt",
            displayName: "Created At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "updatedAt",
            displayName: "Updated At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "variantSkus",
            displayName: "Variants",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "200px",
            sortable: false,
            filterable: true,
        },
        {
            columnName: "unitCost",
            displayName: "Unit Cost ($)",
            cellType: CellType.numberInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "130px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "juniperServiceFee",
            displayName: "Service Fee ($)",
            cellType: CellType.numberInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "fulfillmentFee",
            displayName: "Fulfillment Fee ($)",
            cellType: CellType.numberInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "165px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "processingFeePercent",
            displayName: "Processing Fee (%)",
            cellType: CellType.numberInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "165px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "shippingSubsidy",
            displayName: "Shipping Subsidy ($)",
            cellType: CellType.numberInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "170px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "costPayoutModifierId",
            displayName: "Cost Payout Modifier",
            cellType: CellType.singleSelect,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "200px",
            sortable: false,
            filterable: false,
            textAlign: "left",
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.DESCENDING,
        sortColumn: "startDate",
        pageSize: 50,
    },
};
